var map = {
	"./accrued.svg": "a21b",
	"./accruedAdmin.svg": "d76d",
	"./accruedDomonetization.svg": "01ba",
	"./amountCancelled.svg": "b7b2",
	"./approve.svg": "440d",
	"./approveCPL.svg": "7ff9",
	"./approveClean.svg": "f798",
	"./arrowStatus.svg": "c2ee",
	"./averageMoneyCommission.svg": "cb28",
	"./commission.svg": "5d93",
	"./commissionDomonetization.svg": "c2a7",
	"./commissionLeads.svg": "e14d",
	"./filteredLeads.svg": "4f7e",
	"./leadCancelled.svg": "821c",
	"./leadConfirmed.svg": "8a3f",
	"./leadIntegrated.svg": "b607",
	"./leadProcessed.svg": "e0e0",
	"./leadSpamByAdvertiser.svg": "29f6",
	"./leadTrash.svg": "9baa",
	"./leads.svg": "e8d9",
	"./leadsFilteredSpam.svg": "50d4",
	"./leadsHold.svg": "bd20",
	"./moneyConfirmed.svg": "77ef",
	"./redemption.svg": "306b",
	"./statistic/accruedAdmin.svg": "74c6",
	"./statistic/accruedDomonetization.svg": "6aa0",
	"./statistic/amount.svg": "aa90",
	"./statistic/amountFTD.svg": "b39a",
	"./statistic/amountSD.svg": "f790",
	"./statistic/approve.svg": "d537",
	"./statistic/approveByCPL.svg": "7c8d",
	"./statistic/approveClean.svg": "51a2",
	"./statistic/averageMoneyCommission.svg": "fcf8",
	"./statistic/cleanCr.svg": "7bbf",
	"./statistic/clicksFlow.svg": "2e08",
	"./statistic/clicksLandingEpc.svg": "cf1b",
	"./statistic/clicksLandings.svg": "efc0",
	"./statistic/clicksTransit.svg": "b236",
	"./statistic/commission.svg": "3c17",
	"./statistic/commissionAgent.svg": "6854",
	"./statistic/commissionDomonetization.svg": "78dc",
	"./statistic/commissionLeads.svg": "fda3",
	"./statistic/competition.svg": "c096",
	"./statistic/conversionDomonetization.svg": "4406",
	"./statistic/cr.svg": "b648",
	"./statistic/crFTD.svg": "39a9",
	"./statistic/crFTD_Regs.svg": "62a6",
	"./statistic/crSD.svg": "fbc2",
	"./statistic/crSD_FTD.svg": "0009",
	"./statistic/domonetizationApprove.svg": "e0a8",
	"./statistic/domonetizationClicks.svg": "fc60",
	"./statistic/domonetizationLeads.svg": "c79c",
	"./statistic/firstDeposit.svg": "28d4",
	"./statistic/flowEpc.svg": "a8a1",
	"./statistic/indicatorsEpc.svg": "1b32",
	"./statistic/landingEpc.svg": "44a7",
	"./statistic/leadCancelled.svg": "461a",
	"./statistic/leadConfirmed.svg": "a483",
	"./statistic/leadIntegrated.svg": "a5fb",
	"./statistic/leadProcessed.svg": "0ed6",
	"./statistic/leadSpamByAdvertiser.svg": "834b",
	"./statistic/leadTrash.svg": "dd45",
	"./statistic/leads.svg": "676a",
	"./statistic/leadsFilteredSpam.svg": "ae85",
	"./statistic/leadsHold.svg": "b03c",
	"./statistic/moneyConfirmed.svg": "9ba1",
	"./statistic/moneyWebmasterAccrued.svg": "a760",
	"./statistic/redemption.svg": "625c",
	"./statistic/registrations.svg": "9fac",
	"./statistic/secondDeposits.svg": "06de",
	"./statistic/transitEpc.svg": "0321",
	"./statistic/transitToLanding.svg": "38d1",
	"./statistic/uniques.svg": "482a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd94";